import React, { useEffect, useState, useRef } from 'react';
import JSONEditor from 'jsoneditor';
import toastr from 'toastr';
import http from '../shared/http';
import defaultCreative from './defaultCreative';
import SandboxCreative from './SandboxCreative';
import 'jsoneditor/dist/jsoneditor.css';

const SandboxCreativeBuilder = () => {
  const [editor, setEditor] = useState(null);
  const [butlerResponse, setButlerResponse] = useState(null);
  const [bulterResponseRendered, setButlerResponseRendered] = useState(false);
  const jsoneditorContainer = useRef(null);

  const defaultTemplate =
    defaultCreative.placement.placementAttributes.template;

  const handleJsoneditorChange = () => {
    setButlerResponseRendered(false);
  };

  useEffect(() => {
    // create the editor
    const options = {
      modes: ['tree', 'text'],
      mode: 'text',
      onChange: handleJsoneditorChange
    };
    const editor = new JSONEditor(jsoneditorContainer.current, options);
    setEditor(editor);
  }, []);

  useEffect(() => {
    if (!editor) {
      return;
    }
    setButlerResponse(defaultCreative);
  }, [editor]);

  useEffect(() => {
    if (!butlerResponse) {
      return;
    }

    editor.set(butlerResponse);
  }, [butlerResponse]);

  const handleRender = () => {
    const editorValue = editor.get();

    if (editorValue.placement && editorValue.placement.placementAttributes) {
      editorValue.placement.placementAttributes.template = defaultTemplate;
    }
    setButlerResponse(editorValue);
    setButlerResponseRendered(true);
  };

  const handleSave = () => {
    http
      .post('/sandbox_creatives', {
        sandbox_creative: {
          butler_response: butlerResponse
        }
      })
      .then(response => {
        window.location.replace(response.data.url);
      })
      .catch(() => {
        toastr.error('Something went wrong, please try again!');
      });
  };

  return (
    <div className="container jsoneditor-container mt5">
      {butlerResponse && <SandboxCreative butlerResponse={butlerResponse} />}
      {bulterResponseRendered ? (
        <button
          className="mb2 btn btn-primary"
          type="button"
          data-testid="save-button"
          onClick={handleSave}
        >
          Save
        </button>
      ) : (
        <button
          className="mb2 btn btn-secondary"
          type="button"
          data-testid="render-button"
          onClick={handleRender}
        >
          Render
        </button>
      )}
      <div
        id="jsoneditor"
        style={{ width: '100%', height: '600px' }}
        className="mb5"
        ref={jsoneditorContainer}
      />
    </div>
  );
};

window.SandboxCreativeBuilder = SandboxCreativeBuilder;

export default SandboxCreativeBuilder;
